import styled from 'styled-components';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
const PropertyInputMultiplePropertyPopoverBody = styled(UIPopoverBody).withConfig({
  displayName: "PropertyInputMultiplePropertyPopoverBody",
  componentId: "sc-12xfwsh-0"
})(["max-height:50vh;overflow-y:auto;"]);
export default PropertyInputMultiplePropertyPopoverBody;